import { VehicleAccess } from "../../interfaces";
import { VehicleAccessFormData } from "./interfaces";

/**
 * Transforms a vehicle access into the shape required for the form.
 *
 * - Flattens vehicles into a list of IDs
 */
export function vehicleAccessToFormValues(
  vehicleAccess: VehicleAccess
): VehicleAccessFormData {
  return {
    id: vehicleAccess.id,
    accountId: vehicleAccess.accountId,
    name: vehicleAccess.name,
    hasAccessToAllVehicles: vehicleAccess.hasAccessToAllVehicles,
    vehicles: vehicleAccess.vehicles,
  };
}
